import { useState, useEffect } from "react";
import { Btn, Card, Inp, Lbl, Slct } from "../ui";
import { spls, SIGTE_PLATFORM_SESSION_KEY, sigtePlatformApiFetch, sigtePlatformApiFetchChecked } from "./sigtePlatformUtils";
import { SigtePlatformLogin } from "./SigtePlatformLogin";

var BRAND = "#0F2C70";
var NEW_EMPRESA_BLANK = {nombre:"",slug:"",admin_username:"",admin_password:"",admin_nombre:""};

function DeleteEmpresaModal(p){
  var empresa = p.empresa;
  var [texto,setTexto]=useState("");
  var [busy,setBusy]=useState(false);
  var [err,setErr]=useState("");
  var matches = texto.trim() === empresa.nombre;

  function confirm(){
    setBusy(true); setErr("");
    p.onConfirm().catch(function(e){ setErr(e.message); setBusy(false); });
  }

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"#fff",borderRadius:14,padding:24,width:"100%",maxWidth:420,boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <p style={{fontSize:15,fontWeight:700,color:"#0f172a",margin:"0 0 8px"}}>Eliminar empresa</p>
        <p style={{fontSize:13,color:"#64748b",margin:"0 0 16px"}}>
          Esto borra <b>permanentemente</b> a "{empresa.nombre}" y todos sus usuarios, clientes, edificios, equipos y catalogos. No se puede deshacer.
        </p>
        <Lbl c={'Escribe "'+empresa.nombre+'" para confirmar'}/>
        <Inp value={texto} onChange={function(e){setTexto(e.target.value);}} placeholder={empresa.nombre}/>
        {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#dc2626",marginTop:12}}>{err}</div>:null}
        <div style={{display:"flex",gap:10,marginTop:18}}>
          <button onClick={p.onCancel} style={{flex:1,padding:"10px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
          <button onClick={confirm} disabled={!matches||busy} style={{flex:1,padding:"10px 0",borderRadius:9,border:"none",background:"#dc2626",color:"#fff",fontWeight:700,fontSize:13,cursor:matches?"pointer":"default",opacity:matches?1:0.5}}>{busy?"Eliminando...":"Eliminar definitivamente"}</button>
        </div>
      </div>
    </div>
  );
}

function ResetPasswordModal(p){
  var empresa = p.empresa;
  var [usuarios,setUsuarios]=useState([]);
  var [loading,setLoading]=useState(true);
  var [usuarioId,setUsuarioId]=useState("");
  var [password,setPassword]=useState("");
  var [err,setErr]=useState("");
  var [busy,setBusy]=useState(false);

  useEffect(function(){
    sigtePlatformApiFetch("/empresas/"+empresa.id+"/usuarios").then(function(r){return r.json();}).then(function(d){
      setUsuarios(d.usuarios||[]); setLoading(false);
    });
  },[empresa.id]);

  function confirm(){
    if(!usuarioId){setErr("Selecciona un usuario.");return;}
    if(!password){setErr("Escribe la nueva contrasena.");return;}
    setBusy(true); setErr("");
    p.onConfirm(usuarioId,password).catch(function(e){ setErr(e.message); setBusy(false); });
  }

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"#fff",borderRadius:14,padding:24,width:"100%",maxWidth:400,boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <p style={{fontSize:15,fontWeight:700,color:"#0f172a",margin:"0 0 16px"}}>{"Resetear contrasena - "+empresa.nombre}</p>
        {loading?(
          <p style={{fontSize:13,color:"#64748b"}}>Cargando usuarios...</p>
        ):(
          <div>
            <div style={{marginBottom:14}}>
              <Lbl c="Usuario"/>
              <Slct value={usuarioId} onChange={function(e){setUsuarioId(e.target.value);}}>
                <option value="">Selecciona...</option>
                {usuarios.map(function(u){return <option key={u.id} value={u.id}>{u.nombre+" (@"+u.username+")"}</option>;})}
              </Slct>
            </div>
            <div style={{marginBottom:14}}>
              <Lbl c="Nueva contrasena"/>
              <Inp value={password} onChange={function(e){setPassword(e.target.value);}}/>
            </div>
          </div>
        )}
        {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#dc2626",marginBottom:12}}>{err}</div>:null}
        <div style={{display:"flex",gap:10}}>
          <button onClick={p.onCancel} style={{flex:1,padding:"10px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
          <Btn onClick={confirm} sx={{flex:1}}>{busy?"Guardando...":"Resetear"}</Btn>
        </div>
      </div>
    </div>
  );
}

function EmpresaFormModal(p){
  var editing = p.editing;
  var [form,setForm]=useState(editing ? {nombre:editing.nombre,slug:editing.slug} : NEW_EMPRESA_BLANK);
  var [err,setErr]=useState("");
  var [busy,setBusy]=useState(false);

  function setF(k,v){ setForm(function(f){return Object.assign({},f,{[k]:v});}); }

  function confirm(){
    if(!form.nombre.trim()||!form.slug.trim()){setErr("Nombre y slug son requeridos.");return;}
    if(!editing && (!form.admin_username||!form.admin_password||!form.admin_nombre)){
      setErr("Completa los datos del primer usuario.");return;
    }
    setBusy(true); setErr("");
    p.onConfirm(form).catch(function(e){ setErr(e.message); setBusy(false); });
  }

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:"#fff",borderRadius:14,padding:24,width:"100%",maxWidth:420,boxShadow:"0 20px 60px rgba(0,0,0,0.2)"}}>
        <p style={{fontSize:15,fontWeight:700,color:"#0f172a",margin:"0 0 16px"}}>{editing?"Editar empresa":"Nueva empresa"}</p>
        <div style={{marginBottom:12}}><Lbl c="Nombre"/><Inp value={form.nombre} onChange={function(e){setF("nombre",e.target.value);}}/></div>
        <div style={{marginBottom:12}}><Lbl c="Slug (identificador de login)"/><Inp value={form.slug} onChange={function(e){setF("slug",e.target.value.toLowerCase().replace(/\s/g,"-"));}}/></div>
        {!editing?(
          <div style={{borderTop:"1px solid #f1f5f9",paddingTop:12,marginTop:4,marginBottom:12}}>
            <p style={{fontSize:12,fontWeight:700,color:"#0f172a",margin:"0 0 10px"}}>Primer usuario (admin de la empresa)</p>
            <div style={{marginBottom:12}}><Lbl c="Nombre completo"/><Inp value={form.admin_nombre} onChange={function(e){setF("admin_nombre",e.target.value);}}/></div>
            <div style={{marginBottom:12}}><Lbl c="Usuario"/><Inp value={form.admin_username} onChange={function(e){setF("admin_username",e.target.value);}}/></div>
            <div style={{marginBottom:12}}><Lbl c="Contrasena"/><Inp value={form.admin_password} onChange={function(e){setF("admin_password",e.target.value);}}/></div>
          </div>
        ):null}
        {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 14px",fontSize:13,color:"#dc2626",marginBottom:12}}>{err}</div>:null}
        <div style={{display:"flex",gap:10}}>
          <button onClick={p.onCancel} style={{flex:1,padding:"10px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
          <Btn onClick={confirm} sx={{flex:1}}>{busy?"Guardando...":"Guardar"}</Btn>
        </div>
      </div>
    </div>
  );
}

export default function SigtePlatformApp() {
  var [session,setSession]=useState(function(){return spls.get(SIGTE_PLATFORM_SESSION_KEY,null);});
  var [empresas,setEmpresas]=useState([]);
  var [loading,setLoading]=useState(true);
  var [listErr,setListErr]=useState("");
  var [formModal,setFormModal]=useState(null);
  var [deleteTarget,setDeleteTarget]=useState(null);
  var [resetTarget,setResetTarget]=useState(null);

  function load(){
    setListErr("");
    sigtePlatformApiFetchChecked("/empresas").then(function(d){
      setEmpresas(d.empresas||[]); setLoading(false);
    }).catch(function(e){
      setListErr(e.message); setLoading(false);
    });
  }
  useEffect(function(){ if(session) load(); },[session]);

  function login(a){ spls.set(SIGTE_PLATFORM_SESSION_KEY,a); setSession(a); }
  function logout(){
    sigtePlatformApiFetch("/logout",{method:"POST"}).catch(function(){});
    spls.set(SIGTE_PLATFORM_SESSION_KEY,null); setSession(null);
  }

  async function saveEmpresa(form){
    if(formModal.editing){
      await sigtePlatformApiFetchChecked("/empresas/"+formModal.editing.id,{method:"PUT",body:JSON.stringify(form)});
    } else {
      await sigtePlatformApiFetchChecked("/empresas",{method:"POST",body:JSON.stringify(form)});
    }
    setFormModal(null); load();
  }

  async function deleteEmpresa(){
    await sigtePlatformApiFetchChecked("/empresas/"+deleteTarget.id,{method:"DELETE"});
    setDeleteTarget(null); load();
  }

  async function resetPassword(usuarioId,password){
    await sigtePlatformApiFetchChecked("/usuarios/"+usuarioId+"/reset-password",{method:"POST",body:JSON.stringify({password:password})});
    setResetTarget(null);
  }

  if(!session) return <SigtePlatformLogin onLogin={login}/>;

  return (
    <div style={{minHeight:"100vh",background:"#f1f5f9",fontFamily:"'Inter','Segoe UI',sans-serif"}}>
      {formModal?<EmpresaFormModal editing={formModal.editing} onCancel={function(){setFormModal(null);}} onConfirm={saveEmpresa}/>:null}
      {deleteTarget?<DeleteEmpresaModal empresa={deleteTarget} onCancel={function(){setDeleteTarget(null);}} onConfirm={deleteEmpresa}/>:null}
      {resetTarget?<ResetPasswordModal empresa={resetTarget} onCancel={function(){setResetTarget(null);}} onConfirm={resetPassword}/>:null}
      <div style={{background:BRAND,padding:"14px 28px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <p style={{color:"#fff",fontWeight:800,fontSize:16,margin:0,fontFamily:"Georgia,serif",letterSpacing:2}}>SIGTE · Plataforma</p>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <span style={{color:"rgba(255,255,255,0.7)",fontSize:12}}>{session.nombre}</span>
          <button onClick={logout} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,padding:"8px 14px",color:"#fff",fontSize:12,cursor:"pointer",fontWeight:600}}>Cerrar sesion</button>
        </div>
      </div>
      <div style={{maxWidth:1000,margin:"0 auto",padding:"32px 20px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
          <div><h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>Empresas</h1><p style={{color:"#64748b",fontSize:13,marginTop:3}}>{empresas.length+" empresas"}</p></div>
          <Btn onClick={function(){setFormModal({editing:null});}}>+ Nueva empresa</Btn>
        </div>
        {listErr?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 16px",fontSize:13,color:"#dc2626",marginBottom:16}}>{listErr}</div>:null}
        {loading?(
          <p style={{color:"#64748b",fontSize:14}}>Cargando...</p>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {empresas.map(function(e){
              return (
                <Card key={e.id} sx={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
                  <div>
                    <p style={{margin:0,fontWeight:700,fontSize:14,color:"#0f172a"}}>{e.nombre}</p>
                    <p style={{margin:"2px 0 0",fontSize:12,color:"#64748b"}}>{"/sigte · "+e.slug+(e.activa?"":" · inactiva")}</p>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={function(){setResetTarget(e);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:BRAND,fontSize:12,fontWeight:600,cursor:"pointer"}}>Resetear contrasena</button>
                    <button onClick={function(){setFormModal({editing:e});}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer"}}>Editar</button>
                    <button onClick={function(){setDeleteTarget(e);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #fecaca",background:"#fef2f2",color:"#dc2626",fontSize:12,fontWeight:600,cursor:"pointer"}}>Eliminar</button>
                  </div>
                </Card>
              );
            })}
            {empresas.length===0?<p style={{color:"#94a3b8",fontSize:13}}>No hay empresas registradas.</p>:null}
          </div>
        )}
      </div>
    </div>
  );
}
